<template>
  <div class="room-owe-fee-callable-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('roomOweFeeCallable.title')" :subtitle="$t('roomOweFeeCallable.page.subtitle')">
    </ds-page-header>

    <!-- 表单面板 -->
    <div class="ds-panel">
      <el-form label-position="right" label-width="120px" class="ds-form">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item :label="$t('roomOweFeeCallable.callableWay')">
              <el-select v-model="roomOweFeeCallableInfo.callableWay" class="w-full"
                :placeholder="$t('roomOweFeeCallable.selectCallableWay')">
                <el-option disabled value="" :label="$t('roomOweFeeCallable.selectCallableWay')" />
                <el-option label="微信模板消息" value="WECHAT" />
                <el-option label="短信" value="SMS" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item :label="$t('roomOweFeeCallable.callableFees')">
              <el-checkbox-group v-model="roomOweFeeCallableInfo.feeIds" class="ds-checkbox-group">
                <el-checkbox v-for="(item, index) in roomOweFeeCallableInfo.fees" :key="index" :label="item.feeId">
                  {{ item.feeName }}
                </el-checkbox>
              </el-checkbox-group>
              <span v-if="!roomOweFeeCallableInfo.fees.length" class="ds-text-muted">
                {{ $t('roomOweFeeCallable.page.noFees') }}
              </span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item :label="$t('roomOweFeeCallable.remark')">
              <el-input v-model="roomOweFeeCallableInfo.remark" type="textarea" :rows="5" class="w-full"
                :placeholder="$t('roomOweFeeCallable.inputRemark')" />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 表单操作区 -->
        <div class="ds-form-actions">
          <el-button icon="el-icon-close" @click="goBack">
            {{ $t('common.cancel') }}
          </el-button>
          <el-button type="primary" icon="el-icon-check" @click="_saveOweFeeCallable">
            {{ $t('common.submit') }}
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { saveOweFeeCallable, listFee } from '@/api/fee/roomOweFeeCallableApi'
import { getCommunityId } from '@/api/community/communityApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'

export default {
  name: 'RoomOweFeeCallableList',
  components: {
    DsPageHeader
  },
  data() {
    return {
      roomOweFeeCallableInfo: {
        callableWay: '',
        remark: '',
        communityId: '',
        feeIds: [],
        roomId: '',
        roomIds: [],
        fees: []
      }
    }
  },
  created() {
    this.roomOweFeeCallableInfo.communityId = getCommunityId()
    this.roomOweFeeCallableInfo.roomId = this.$route.query.roomId
    this.roomOweFeeCallableInfo.roomIds.push(this.$route.query.roomId)
    this._loadRoomOweFees()
  },
  methods: {
    roomOweFeeCallableValidate() {
      if (!this.roomOweFeeCallableInfo.callableWay) {
        this.$message.error(this.$t('roomOweFeeCallable.callableWayRequired'))
        return false
      }
      return true
    },
    async _saveOweFeeCallable() {
      if (!this.roomOweFeeCallableValidate()) {
        return
      }

      try {
        const res = await saveOweFeeCallable(this.roomOweFeeCallableInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('common.operationSuccess'))
          this.goBack()
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        this.$message.error(this.$t('common.submitError'))
      }
    },
    async _loadRoomOweFees() {
      try {
        const params = {
          page: 1,
          row: 100,
          communityId: this.roomOweFeeCallableInfo.communityId,
          payerObjId: this.roomOweFeeCallableInfo.roomId,
          state: '2008001'
        }
        const { fees } = await listFee(params)
        this.roomOweFeeCallableInfo.fees = fees || []
      } catch (error) {
        console.error('获取欠费费用列表失败:', error)
        this.$message.error(this.$t('roomOweFeeCallable.fetchFeeError'))
      }
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.room-owe-fee-callable-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  padding: var(--ds-spacing-lg);
}

/* 表单 */
.ds-form {
  .el-form-item {
    margin-bottom: var(--ds-spacing-lg);
  }
}

/* 复选框组 */
.ds-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: var(--ds-spacing-xs) var(--ds-spacing-md);

  .el-checkbox {
    margin-right: 0;
  }
}

/* 辅助文本 */
.ds-text-muted {
  font-size: var(--ds-font-size-sm);
  color: var(--ds-gray-500);
}

/* 表单操作区 */
.ds-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--ds-spacing-sm);
  padding-top: var(--ds-spacing-md);
  border-top: 1px solid var(--ds-gray-200);
}
</style>
